import cuid from "cuid";
import { get } from "lodash";
import { useState } from "react";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import Loader from "../Components/Loader";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SelectBranch = ({ project, currentStatus, onNext, tracer }) => {
  const [selectedBranch, setSelectedBranch] = useState(
    get(project, "fields.branch"),
  );
  const { data, loading } = useQuery(graphql.queries.ORGANIZATION_BRANCHES, {
    variables: {
      where: {
        active: true,
      },
    },
  });

  const onSubmit = () =>
    onNext({
      payload: {
        fields: {
          ...get(project, "fields"),
          branch: selectedBranch,
          shouldBeHidden: true,
        },
        contact: {
          id: cuid(),
          ...get(project, "contact"),
        },
      },
    });

  if (loading) return <Loader />;
  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        showHelp={false}
      />
      <View
        branches={get(data, "organizationBranches.data", [])}
        onNext={onSubmit}
        selectedBranch={selectedBranch}
        setSelectedBranch={setSelectedBranch}
      />
    </>
  );
};

export default SelectBranch;
